import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import ContractorSEO from "@/pages/ContractorSEO";

export const Route = createFileRoute("/contractor-seo")({
  component: ContractorSEO,
  head: () =>
    pageHead({
      title: "Contractor SEO Seattle | Rank for Local Jobs | jaik",
      description: "SEO for Seattle contractors: roofing, plumbing, remodeling. Get top Google rankings in King County. Included with every website build.",
      path: "/contractor-seo",
    }),
});
